// JSX port of realnews-web's ui/Checkbox. Keep in sync.
function Checkbox({ className = "", ...props }) {
  return (
    <input
      type="checkbox"
      className={`size-2xl rounded-xxs border border-border-edge-strong-light accent-brand-blue dark:border-border-edge-strong-dark ${className} `}
      {...props}
    />
  );
}

export default Checkbox;
